export default "__VITE_ASSET__BbjEDhO0__"